import { render } from "./HeroiconsOutlineZoomIn.vue?vue&type=template&id=5bbb8a84"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineZoomIn.vue"]])

export default __exports__